var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 129 135",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 175.50017,
    height: 23.052984,
    x: 5.5335188,
    y: -12.028658,
    ry: 12.530534,
    transform: "matrix(0.68651656,0.72711417,-0.72128686,0.69263646,0,0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 175.50017,
    height: 23.052984,
    x: -83.794197,
    y: 82.025642,
    ry: 12.530534,
    transform: "matrix(-0.68651656,0.72711417,0.72128686,0.69263646,0,0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.62bb5bb5fc3750d82b6d8a7adeb23418.svg";
export { ForwardRef as ReactComponent };